import React from "react";
import SubmitButton from "./SubmitButton";

export default function CommonReasonPopup({
    open,
    onClose,
    value,
    onChange,
    onSubmit,
    loading = false,
    buttonText = "Submit",
    placeholder = "Type your reason here...",
}) {
    if (!open) return null;

    return (
        <div onClick={onClose} className="img-popup-design1">
            <div style={{ paddingBottom: 15 }} className="img-popup1" onClick={(e) => e.stopPropagation()}>
                {/* Close Button */}
                <button className="close-btn" onClick={onClose}>
                    ×
                </button>

                {/* Textarea */}
                <textarea
                    className="input-box3 f2"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    placeholder={placeholder}
                    rows="4"
                />

                {/* Action Button */}
                <div className="d-flex ac-jc px-1 py-1">

                    <div className="mt-2 w-100">
                        <SubmitButton
                            onClick={onSubmit}
                            title={buttonText}
                            disabled={!value || loading}
                            isFormValid={!value || loading}
                            loading={loading}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}